module.exports = __webpack_public_path__ + "img/ia.fbc8d745.svg";